import { Directive, inject, Plugin, provide, Ref, ref } from "vue";
import { AppTheme } from "./types";

export type ThemeContext = Ref<AppTheme>;

const themeContextKey = "app-theme";

const globalTheme = ref(window.page.theme);

export function provideTheme() {
  const theme = ref(window.page.theme);
  provide<ThemeContext>(themeContextKey, theme);
}

export function useTheme() {
  return inject<ThemeContext>(themeContextKey, ref(window.page.theme));
}

export const uiTheme: Directive<HTMLElement, AppTheme> = {
  created: (el, theme) => {
    el.dataset["bs-theme"] = theme.value;
  },
};

export const themePlugin: Plugin<void> = {
  install: (app) => {
    app.provide(themeContextKey, globalTheme);
  },
};
